import { SET_DROP_DOWN_ALERT_INFO } from "../actions/types";
import { isNative, isWeb } from "../styles/commonStyles";
import * as DocumentPicker from "expo-document-picker";
// SDK 54 ships the new File/Directory API at the package root and throws on
// the old function API; the legacy entrypoint keeps these calls working.
import * as FileSystem from "expo-file-system/legacy";

const MAX_PDF_SIZE = 10 * 1024 * 1024; // 10MB in bytes

export async function pickDocument(dispatch) {
	const files = [];
	let value;

	try {
		const result = await DocumentPicker.getDocumentAsync({
			type: "application/pdf",
			copyToCacheDirectory: true
		});

		if (!result.canceled && result.assets && result.assets.length > 0) {
			const asset = result.assets[0];
			const uri = asset.uri;
			const name = asset.name || `document_${Date.now()}.pdf`;
			const size = asset.size;

			// Check file size (10MB limit)
			if (size && size > MAX_PDF_SIZE) {
				dispatch({
					type: SET_DROP_DOWN_ALERT_INFO,
					info: "pdfsizelimit"
				});
				return;
			}

			// For native, also check file size using FileSystem if size is not available from asset
			if (!isWeb && (!size || size === 0)) {
				try {
					const fileInfo = await FileSystem.getInfoAsync(uri);
					if (fileInfo.exists && fileInfo.size > MAX_PDF_SIZE) {
						dispatch({
							type: SET_DROP_DOWN_ALERT_INFO,
							info: "pdfsizelimit"
						});
						return;
					}
				} catch (error) {
					console.error("Error getting file info:", error);
					// Continue anyway, will fail later if file is too large
				}
			}

			if (isWeb) {
				// On web `uri` is a `blob:` URL; `asset.base64` is the full data URL
				// (expo-document-picker reads the file with readAsDataURL).
				files.push({
					name: name.replace(/\.pdf$/i, ""),
					base64: asset.base64
				});
				value = uri;
			} else {
				// For native, read the file and convert to base64
				try {
					const base64 = await FileSystem.readAsStringAsync(uri, {
						encoding: FileSystem.EncodingType.Base64
					});
					files.push({
						name: name.replace(/\.pdf$/i, ""),
						base64: `data:application/pdf;base64,${base64}`
					});
					value = uri;
				} catch (error) {
					console.error("Error reading PDF file:", error);
					dispatch({
						type: SET_DROP_DOWN_ALERT_INFO,
						info: "errorreadingpdf"
					});
					return;
				}
			}
		}
	} catch (error) {
		console.error("Error picking document:", error);
		dispatch({
			type: SET_DROP_DOWN_ALERT_INFO,
			info: "errorpickingpdf"
		});
		return;
	}

	return {
		files,
		value
	};
}
